import { render, staticRenderFns } from "./GalleryEventListing.vue?vue&type=template&id=1b5c2954&scoped=true&"
import script from "./GalleryEventListing.vue?vue&type=script&lang=js&"
export * from "./GalleryEventListing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b5c2954",
  null
  
)

export default component.exports